module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/menu/ppt_icon-1ef357.svg";